export interface HalalProps {
    isBadgeActive: boolean
}

export const useHalal = (props: HalalProps) => {
  return {
    ...props,
  }
}
